export var UPDATE_URL = 'UPDATE_URL';